
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13407',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13407",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1010",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10055",
  "foundations-components": "static-1.8647",
  "foundations-components-legacy": "static-1.1672",
  "foundations-theming": "static-1.4889",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8449",
  "hub-http-shared-msw-handlers": "static-1.10791",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11900",
  "I18n": "static-7.1691",
  "jasmine-runner": "static-1.6858",
  "marketplace-discovery-studio-lib": "static-1.802",
  "marketplace-storefront-base": "static-1.13470",
  "quartz": "static-1.7581",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "static-1.3262",
  "reporting-testing-lib": "static-1.11091",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12939",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7761",
  "ui-addon-i18n": "static-1.11557",
  "ui-addon-react-router-dom": "static-1.9940",
  "unified-auth": "static-1.1123",
  "unified-auth-core-lib": "static-1.1405",
  "usage-tracker": "static-1.7723",
  "usage-tracker-core": "static-1.7573",
  "customer-data-property-utils": "static-1.8464",
  "hub-http": "static-1.6619",
  "integrations-lib": "static-1.17290",
  "marketplace-ui-common": "static-1.20944",
  "marketplace-ui-install": "static-1.930",
  "property-management-iframe": "static-1.14335",
  "quartz-config": "static-1.1359",
  "quartz-core": "static-1.6800",
  "quartz-routing": "static-1.1011",
  "quick-fetch": "static-1.4190",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5078",
  "ts-schema": "static-1.4358",
  "ui-universal-auth": "static-1.9609",
  "UIComponents": "static-3.8846",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3858",
  "quartz-webpack": "static-1.3805",
  "bend-plugin-quartz-routing": "static-1.659",
  "ai-components-ui-library": "static-1.9912",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5296",
  "pulse": "static-1.1048",
  "react-codemirror": "static-1.11049",
  "ui-extensions-preview-lib": "static-1.807",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4916",
  "floating-ui": "static-1.66",
  "foundations-theming-specialty": "static-1.2605",
  "framer-motion": "static-1.82",
  "hs-story-utils": "static-1.9836",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5621",
  "react-virtualized": "static-2.110",
  "StyleGuideUI": "static-3.512",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2932",
  "ui-fonts": "static-1.1162",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3372",
  "foundations-theming-base": "static-1.3874",
  "stylex": "static-1.45",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3560",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4719",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11291",
  "chirp-fetch": "static-1.2310",
  "connections-embed-lib": "static-1.1655",
  "copilot-toolkit": "static-1.12031",
  "feedback-loader": "static-1.29963",
  "laboratory-lib": "static-3.7561",
  "marketplace-embed": "static-1.23091",
  "marketplace-ui-details": "static-1.10839",
  "marketplace-ui-reviews": "static-1.20899",
  "marketplace-ui-tracking": "static-1.15114",
  "sanitize-text": "static-1.8568",
  "usage-tracker-multi": "static-1.6137",
  "usage-tracker-session-replay": "static-1.5409",
  "wootric-nps": "static-1.7262",
  "quartz-head": "static-1.1246",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5019",
  "immer": "static-1.104",
  "immerable": "static-1.4553",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2774",
  "reporting-data": "static-1.69158",
  "cssUtils": "static-1.1031",
  "flux-actions": "static-1.378",
  "react-colorpicker": "static-2.10621",
  "react-dnd-compat": "static-1.5022",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10781",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7713",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19476",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4917",
  "foundations-components-test-utils": "static-1.6130",
  "quartz-i18n": "static-1.1256",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.653",
  "ads-unified-auth-lib": "static-1.1747",
  "custom-vendor-connection-lib": "static-1.173",
  "google-sheets-integration-lib": "static-1.1217",
  "microsoft-drive-auth-lib": "static-1.380",
  "surveymonkey-integration-lib": "static-1.748",
  "slack-ui-library": "static-1.10807",
  "fsm": "static-1.4163",
  "customer-data-objects": "static-1.8103",
  "property-translator": "static-1.5790",
  "hs-locale-management": "static-1.359",
  "frontend-preferences-client": "static-1.8328",
  "hs-promise-utils": "static-1.6000",
  "hubspot-apollo-client": "static-1.5285",
  "integrations-error-boundary-lib": "static-1.14705",
  "integrations-tracking-lib": "static-1.6020",
  "native-integrations-shared-strings": "static-1.8173",
  "sanitize": "static-1.4882",
  "superstore": "static-1.5169",
  "ui-shepherd-react": "static-3.10683",
  "ai-settings-ui-library": "static-1.8482",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4925",
  "immutable-less": "static-1.5060",
  "marketplace-ui-client-types": "static-1.18351",
  "nav-meta": "static-1.30682",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18506",
  "ui-product-approvals-common": "static-1.1404",
  "ai-studio-lib": "static-1.12626",
  "hubspot-prosemirror": "static-1.19167",
  "integrations-reconnect-lib": "static-1.628",
  "ui-addon-iframeable": "static-1.9489",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-product-approvals": "static-1.29509",
  "ui-tool-access": "static-1.10565",
  "inbound-db-properties-service-client": "static-1.4107",
  "property-management-common": "static-1.6623",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "static-1.1256",
  "quartz-test": "static-1.1256",
  "quartz-tracking": "static-1.960",
  "trellis-components": "static-1.2951",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.488",
  "HubStyle": "static-2.12207",
  "bender-build-tools": "static-1.3472",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.111",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23468",
  "ContentUtils": "static-1.69330",
  "customer-data-objects-ui-components": "static-1.13439",
  "sassPrefix": "static-1.298",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.551",
  "batch-promise": "static-1.1956",
  "event-emitter": "static-1.1370",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5847",
  "magpie-types": "static-1.5307",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1391",
  "avatar-components": "static-1.2893",
  "breeze-engine-core": "static-1.1273",
  "breeze-onboarding-components": "static-1.942",
  "customer-data-filters-ui": "static-1.41202",
  "customer-data-reference-ui-components": "static-1.13576",
  "data-integrations-breeze": "static-1.166",
  "embedded-academy-lib": "static-1.15818",
  "ExportDialog": "static-6.10784",
  "global-styles-ai-lib": "static-1.351",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.794",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42258",
  "reporting-snowflake": "static-1.57774",
  "reporting-ui-components": "static-2.66427",
  "reporting-visualizations": "static-1.61232",
  "trial-components-library": "static-1.14290",
  "ui-addon-teams": "static-1.21968",
  "upgrade-components-lib": "static-1.646",
  "navigation-components": "static-1.19045",
  "breeze-engine-lib": "static-1.1995",
  "simple-logging-lib": "static-1.3463",
  "nudge-client-utils": "static-1.3305",
  "fail-safe": "static-1.363",
  "app-governance-lib": "static-1.2573",
  "developer-experience-shared-components": "static-1.10947",
  "purchase-motions-components": "static-1.6553",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10604",
  "usage-tracker-anonymous": "static-1.6140",
  "usage-tracker-public": "static-1.7534",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3739",
  "persist-promise": "static-1.4113",
  "reference-resolvers": "static-1.8590",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4326",
  "hubspot-apollo-cache": "static-1.744",
  "universal-page-editor-lib": "static-1.3420",
  "final-form": "static-1.81",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3710",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6862",
  "ui-addon-draggable": "static-3.5156",
  "content-assistance-lib": "static-1.8334",
  "content-media-capture": "static-1.5659",
  "customer-data-ui-utilities": "static-1.10242",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24728",
  "growth-payments-core": "static-1.26381",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3297",
  "payment-link-components": "static-1.24313",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20458",
  "ui-addon-emoji-picker": "static-1.10278",
  "ui-business-units-lib": "static-1.9504",
  "video-components-external": "static-1.12317",
  "video-data-lib": "static-1.35975",
  "navigation-messaging": "static-1.8372",
  "collaboration-sidebar": "static-1.58929",
  "trellis-ext-dnd": "static-1.445",
  "crm-component-utils": "static-1.40045",
  "crm-properties-common-lib": "static-1.6299",
  "customer-data-properties": "static-1.52867",
  "external-options-client-types": "static-1.4407",
  "framework-data-schema-resolvers": "static-1.7305",
  "property-value-citations": "static-1.3481",
  "reference-resolvers-lite": "static-1.8514",
  "hubspotter-http-shared-msw-handlers": "static-1.10789",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "cms-field-types": "static-1.5223",
  "content-icons-ui": "static-1.2417",
  "atom": "static-1.5488",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1133",
  "breeze-artifacts-sdk": "static-1.659",
  "getting-started-shared-tasks": "static-1.19450",
  "onboarding-journeys-lib": "static-1.1128",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43973",
  "customer-data-filters-ui-msw-helpers": "static-1.23637",
  "events-data-lib": "static-1.657",
  "FormUrlGenerator": "static-2.5123",
  "framework-builder-read-service-client": "static-1.4287",
  "hs-resources": "static-1.604",
  "multi-account-reference-resolvers": "static-1.1412",
  "onboarding-tours": "static-1.17295",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14655",
  "segments-client-types": "static-1.11943",
  "academy-common-lib": "static-1.15278",
  "dashboard-lib": "static-1.83135",
  "hubspot-prosemirror-plugins": "static-1.19159",
  "share-with-third-party-component-lib": "static-1.9120",
  "ui-asset-management-lib": "static-1.11512",
  "user-context": "static-1.5476",
  "reporting-plugins": "static-1.10897",
  "reporting-reports": "static-1.68834",
  "hubs-service-types": "static-1.1673",
  "purchase-motions-api": "static-1.6556",
  "salesImages": "static-1.669",
  "signup-constants": "static-1.19823",
  "nest": "static-1.646",
  "breeze-engine-chat-components": "static-1.973",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3062",
  "nudge-renderer-utils": "static-1.3381",
  "whisper-core-api": "static-1.7520",
  "bend-plugin-fail-safe": "static-1.314",
  "framework-listing-lib": "static-2.29694",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31633",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8469",
  "onboarding-tours-client": "static-1.5510",
  "one-click-checkout": "static-1.635",
  "platform-infra-nav-components": "static-1.7963",
  "subscription-experience-data-types": "static-1.15358",
  "crm-record-cards-service-types": "static-1.3834",
  "location-customization-utils-lib": "static-1.10304",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.81",
  "ui-coaching-tips": "static-1.29494",
  "content-media-composition-data-lib": "static-1.13463",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4836",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3883",
  "seat-types-lib": "static-1.927",
  "ui-addon-opt": "static-4.8785",
  "commerce-tours-lib": "static-1.6769",
  "growth-onboarding-reliability": "static-1.5493",
  "sales-checkout-service-client": "static-1.3939",
  "data-token-picker": "static-1.17034",
  "FileManagerLib": "static-1.40368",
  "content-media-compositions": "static-2.17470",
  "media-bridge-lib": "static-1.19548",
  "chatspot-widget-iframe": "static-1.23459",
  "collaboration-sidebar-common": "static-1.3726",
  "marketing-platform-lib": "static-1.7301",
  "dnd-kit": "static-1.19",
  "card-properties-lib": "static-1.45206",
  "commerce-subscription-lib": "static-1.37980",
  "crm-actions": "static-1.6760",
  "crm-cards-sdk": "static-1.44859",
  "customer-data-properties-shared-msw-handlers": "static-1.10118",
  "customer-data-tracking": "static-1.7283",
  "calling-global-api": "static-1.65971",
  "calling-internal-common": "static-1.31732",
  "calling-lifecycle-internal": "static-1.67353",
  "calling-lifecycle-messages": "static-1.59646",
  "commerce-products-lib": "static-1.10748",
  "conditional-properties-service-client": "static-1.4081",
  "crm-index-visualization-core": "static-1.4670",
  "crm-links": "static-1.6711",
  "crm-pipelines-api-client-types": "static-1.4412",
  "formula-editor": "static-1.14924",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4489",
  "meetings-icalendar-utils-lib": "static-1.1047",
  "multi-currency-client-types": "static-1.3976",
  "object-builder-ui-client": "static-1.49901",
  "pipeline-validation-client-types": "static-1.4248",
  "smart-data-capture-core": "static-1.341",
  "smart-property-lib": "static-1.8511",
  "tiered-pricing": "static-1.2130",
  "topics-actions-lib": "static-1.584",
  "ui-addon-form-validation": "static-1.11337",
  "zustand": "static-1.87",
  "fdsr-migration-layer": "static-1.424",
  "framework-data-schema-quick-fetch": "static-1.7210",
  "restore-request-side-panel-lib": "static-1.1899",
  "growth-data-modal": "static-1.6039",
  "growth-onboarding-confetti": "static-1.3473",
  "growth-onboarding-next-action-utils": "static-1.2874",
  "onboarding-tours-utils": "static-1.1362",
  "ui-shepherd-tracker": "static-1.8064",
  "crm-index-associations-lib": "static-1.6858",
  "academy-service-client": "static-1.4103",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40227",
  "SafeStorage": "static-1.4805",
  "video-embed": "static-1.36809",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25145",
  "viral-links-lib": "static-1.7489",
  "nested-table": "static-1.647",
  "timezone-utils": "static-2.5641",
  "getting-started-shared-tasks-store": "static-1.18568",
  "campaign-roi-lib": "static-1.10630",
  "campaigns-utils-lib": "static-1.3642",
  "ui-addon-calendars": "static-2.5770",
  "customer-data-views-management": "static-1.26210",
  "framework-data-table": "static-2.12733",
  "nudge-custom-ui-functions": "static-1.1646",
  "switchboard-lib": "static-1.632",
  "access-check-ui-lib": "static-1.1777",
  "app-users-service-client": "static-1.6030",
  "app-users-service-types": "static-1.5438",
  "mini-checkout-client": "static-1.27730",
  "onboarding-utils": "static-1.5779",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29479",
  "checkout-sdk": "static-3.24573",
  "payment-method-components": "static-1.7256",
  "touchless-buying-components": "static-1.6441",
  "upgrade-catalog-service-types": "static-1.3836",
  "edison-service-client-types": "static-1.804",
  "growth-onboarding-feedback-components": "static-1.6993",
  "audio-components": "static-1.6482",
  "FileManagerImages": "static-1.37879",
  "video-components": "static-1.14319",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93069",
  "customer-data-sidebar": "static-2.46912",
  "enrichment-lib": "static-1.769",
  "ui-addon-draggable-compat": "static-2.4673",
  "universal-record-utils-lib": "static-1.2227",
  "commerce-billing-lib": "static-1.20422",
  "commerce-shared-components-lib": "static-1.19462",
  "commerce-tools-ui-lib": "static-1.11217",
  "crm-fe-perf": "static-1.23306",
  "calling-error-reporting": "static-1.31739",
  "shared-worker-versioning": "static-1.11451",
  "calling-usage-tracker": "static-1.6946",
  "voice-sms-access-library": "static-1.2301",
  "commerce-permissions": "static-1.1187",
  "products-iframe-lib": "static-1.8774",
  "products-ui-components-shared-msw-handlers": "static-1.11173",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10874",
  "sales-views-client-types": "static-1.4668",
  "bark-lib": "static-1.16939",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.793",
  "policy-lib": "static-1.7215",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10937",
  "onboarding-data-sync-lib": "static-1.2726",
  "growth-onboarding-next-action-components": "static-1.2902",
  "user-context-client": "static-1.4919",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4926",
  "outpost": "static-1.4544",
  "draft-convert": "static-2.82",
  "draft-extend": "static-3.86",
  "draft-js": "static-5.88",
  "draft-plugins": "static-2.22261",
  "sales-email-signature-service-client": "static-1.4257",
  "ts-utils-lib": "static-1.559",
  "copilot-messaging": "static-1.2281",
  "crm-export-dialog": "static-1.6689",
  "crm-index-ui-shimmer": "static-1.2871",
  "crm-view-components": "static-1.1391",
  "react-beautiful-dnd": "static-1.73",
  "customer-data-associations": "static-1.7741",
  "tasks-actions-lib": "static-1.323",
  "InboxConnectUtils": "static-4.15735",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47034",
  "hub-http-rxjs": "static-1.865",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4401",
  "company-details-components": "static-1.6616",
  "react-performance-metrics-lib": "static-1.964",
  "pricing-pages-ui-components": "static-1.16305",
  "quote-checkout-service-types": "static-1.3867",
  "social-insights-client-types": "static-1.22823",
  "crm_universal": "static-1.22628",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38192",
  "commerce-contract-lib": "static-1.13627",
  "invoices-highlight-card-lib": "static-1.56036",
  "orders-highlight-card-lib": "static-1.22382",
  "products-highlight-card-lib": "static-1.19031",
  "quotes-highlight-card-lib": "static-1.72977",
  "crm-source-interpretation-lib": "static-1.5739",
  "data-agent-test-utils": "static-1.337",
  "data-agent-utils": "static-1.806",
  "enrichment-settings-lib": "static-1.114",
  "crm-object-search-query-utilities": "static-1.10360",
  "utility-belt": "static-1.2945",
  "payments-enrollment-embed-lib": "static-1.24084",
  "stripe-embedded-components": "static-1.8142",
  "customer-data-rte": "static-1.33797",
  "cv-backend-services": "static-1.1601",
  "growth-onboarding-empty-states": "static-1.6434",
  "payments-post-enroll-local-storage-lib": "static-1.5514",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39067",
  "calling-orchestration-schema": "static-1.37078",
  "react-reducer-toolkit": "static-1.16554",
  "meetings-connect-utils-lib": "static-1.8026",
  "hub-http-contrib": "static-1.3437",
  "ui-addon-sales-email": "static-1.5614",
  "access-control-lib": "static-1.10839",
  "EmailComponents": "static-1.55733",
  "EmailData": "static-1.54411",
  "messaging-base-table-lib": "static-1.692",
  "redux-less": "static-2.9872",
  "company-details-service-types": "static-1.4353",
  "segments-query-core": "static-1.1838",
  "pricing-pages-api": "static-1.16170",
  "sequences-lib": "static-1.8675",
  "ui-gdpr-components": "static-1.10649",
  "products-ui-components": "static-1.41266",
  "reporting-enablement": "static-1.24040",
  "accounting-integrations-ui-components": "static-1.7701",
  "invoices-ui-lib": "static-1.56052",
  "commerce-products-api": "static-1.2827",
  "invoices-iframe-lib": "static-1.58110",
  "quotes-modal-lib": "static-1.103655",
  "quotes-ui-lib": "static-1.81698",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29053",
  "ContentComponents": "static-2.72286",
  "ContentData": "static-1.69405",
  "marketing-email-service-types": "static-1.2175",
  "messaging-editing-lib": "static-1.47349",
  "messaging-usage-based-billing-components-lib": "static-1.2211",
  "automation-ui-source-apps": "static-1.19866",
  "automation-ui-types": "static-1.20784",
  "messaging-types-lib": "static-1.47086",
  "onboarding-settings-client": "static-1.4919",
  "sequences-client-types-lib": "static-1.8532",
  "commerce-tax-lib": "static-1.948",
  "price-books-api": "static-1.1914",
  "price-books-components": "static-1.1972",
  "property-description-translator": "static-1.4231",
  "ramp-editor": "static-1.1064",
  "data-quality-ui-library": "static-1.14155",
  "report-customization-components": "static-1.14094",
  "reporting-filters": "static-1.1184",
  "reporting-insights-lib": "static-1.2797",
  "commerce-analytics-service-client": "static-1.3927",
  "totals-ui-components": "static-1.24461",
  "SalesContentIndexUI": "static-3.9689",
  "advanced-menus-core": "static-1.15718",
  "advanced-menus-lib": "static-1.12512",
  "automation-ui-ubb": "static-1.6700",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7749",
  "data-token-views": "static-1.17015",
  "forms-utils-lib": "static-1.13239",
  "payments-embed-points-lib": "static-1.13746",
  "react-tinymce": "static-1.56159",
  "simple-menus-core": "static-1.15717",
  "simple-menus-lib": "static-1.17234",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55285",
  "tinymce-data": "static-1.41370",
  "tinymce-plugins": "static-1.58399",
  "tinymce-themes": "static-1.57255",
  "ui-brand-identity-lib": "static-1.16776",
  "ui-memberships-settings-lib": "static-1.35064",
  "videoconference-integration-components": "static-1.7434",
  "automation-applications-service-types": "static-1.3698",
  "automation-platform-service-types": "static-1.2709",
  "ContentEditorUI": "static-2.78116",
  "content-whatsapp-service-types": "static-1.635",
  "short-messages-app-service-client": "static-1.4333",
  "web-interactives-components": "static-1.14395",
  "web-interactives-data": "static-1.14396",
  "messaging-shared-utils-lib": "static-1.1660",
  "messaging-user-info-utils-lib": "static-1.1830",
  "email-portal-health-service-types": "static-1.1392",
  "line-items-api": "static-1.1234",
  "merge-modal-lib": "static-1.12911",
  "commerce-totals-service-types": "static-1.4099",
  "FireAlarmUi": "static-1.4797",
  "sales-templates-service-types-lib": "static-1.4450",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22720",
  "automation-ui-usage-tracking": "static-1.22183",
  "data-studio-ubb": "static-1.3699",
  "interframe": "static-3.5152",
  "layout-dnd-components": "static-1.13118",
  "layout-dnd-utils": "static-1.12093",
  "NamespacedHubStyle": "static-2.9324",
  "campaigns-lib": "static-1.27793",
  "content-management-data-lib": "static-1.6127",
  "copilot-plugins": "static-1.12003",
  "cta-picker": "static-1.37165",
  "customer-agent-discovery-components-lib": "static-1.4153",
  "editor-components": "static-1.13797",
  "editor-iframe-lib": "static-1.8921",
  "error-messaging-js": "static-1.5555",
  "FormsCommonComponents": "static-1.86736",
  "layout-data-lib": "static-1.10418",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.76",
  "redux-request-state": "static-1.11049",
  "SharedLegalStrings": "static-1.2137",
  "smart-content-core": "static-1.43350",
  "smart-content-lib": "static-1.44003",
  "social-composer-lib": "static-1.60480",
  "structured-content-lib": "static-1.26088",
  "theme-previewer-lib": "static-1.54065",
  "tinymce-copilot": "static-1.17353",
  "xray-recommendation-lib": "static-1.8379",
  "automation-ui-routing": "static-1.22141",
  "sql-reporting-client-types": "static-1.5967",
  "attribution-lib": "static-1.42918",
  "voice-agents-components": "static-1.3970",
  "forms-ai-lib": "static-1.4894",
  "codemirror-dlb": "static-1.59675",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6855",
  "calling-orchestration-shared-library": "static-1.36853"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13407",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1010",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10055",
  "foundations-components": "/foundations-components/static-1.8647",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1672",
  "foundations-theming": "/foundations-theming/static-1.4889",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8449",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10791",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11900",
  "I18n": "/I18n/static-7.1691",
  "jasmine-runner": "/jasmine-runner/static-1.6858",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.802",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13470",
  "quartz": "/quartz/static-1.7581",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3262",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11091",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12939",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7761",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11557",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9940",
  "unified-auth": "/unified-auth/static-1.1123",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1405",
  "usage-tracker": "/usage-tracker/static-1.7723",
  "usage-tracker-core": "/usage-tracker-core/static-1.7573",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "hub-http": "/hub-http/static-1.6619",
  "integrations-lib": "/integrations-lib/static-1.17290",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20944",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.930",
  "property-management-iframe": "/property-management-iframe/static-1.14335",
  "quartz-config": "/quartz-config/static-1.1359",
  "quartz-core": "/quartz-core/static-1.6800",
  "quartz-routing": "/quartz-routing/static-1.1011",
  "quick-fetch": "/quick-fetch/static-1.4190",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5078",
  "ts-schema": "/ts-schema/static-1.4358",
  "ui-universal-auth": "/ui-universal-auth/static-1.9609",
  "UIComponents": "/UIComponents/static-3.8846",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3858",
  "quartz-webpack": "/quartz-webpack/static-1.3805",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.659",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9912",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5296",
  "pulse": "/pulse/static-1.1048",
  "react-codemirror": "/react-codemirror/static-1.11049",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.807",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4916",
  "floating-ui": "/floating-ui/static-1.66",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2605",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-story-utils": "/hs-story-utils/static-1.9836",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5621",
  "react-virtualized": "/react-virtualized/static-2.110",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2932",
  "ui-fonts": "/ui-fonts/static-1.1162",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3372",
  "foundations-theming-base": "/foundations-theming-base/static-1.3874",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3560",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4719",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11291",
  "chirp-fetch": "/chirp-fetch/static-1.2310",
  "connections-embed-lib": "/connections-embed-lib/static-1.1655",
  "copilot-toolkit": "/copilot-toolkit/static-1.12031",
  "feedback-loader": "/feedback-loader/static-1.29963",
  "laboratory-lib": "/laboratory-lib/static-3.7561",
  "marketplace-embed": "/marketplace-embed/static-1.23091",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10839",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20899",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15114",
  "sanitize-text": "/sanitize-text/static-1.8568",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6137",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5409",
  "wootric-nps": "/wootric-nps/static-1.7262",
  "quartz-head": "/quartz-head/static-1.1246",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4553",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2774",
  "reporting-data": "/reporting-data/static-1.69158",
  "cssUtils": "/cssUtils/static-1.1031",
  "flux-actions": "/flux-actions/static-1.378",
  "react-colorpicker": "/react-colorpicker/static-2.10621",
  "react-dnd-compat": "/react-dnd-compat/static-1.5022",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10781",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7713",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19476",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4917",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6130",
  "quartz-i18n": "/quartz-i18n/static-1.1256",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.653",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1747",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.173",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1217",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.380",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.748",
  "slack-ui-library": "/slack-ui-library/static-1.10807",
  "fsm": "/fsm/static-1.4163",
  "customer-data-objects": "/customer-data-objects/static-1.8103",
  "property-translator": "/property-translator/static-1.5790",
  "hs-locale-management": "/hs-locale-management/static-1.359",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8328",
  "hs-promise-utils": "/hs-promise-utils/static-1.6000",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5285",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14705",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6020",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8173",
  "sanitize": "/sanitize/static-1.4882",
  "superstore": "/superstore/static-1.5169",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10683",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8482",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4925",
  "immutable-less": "/immutable-less/static-1.5060",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18351",
  "nav-meta": "/nav-meta/static-1.30682",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18506",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1404",
  "ai-studio-lib": "/ai-studio-lib/static-1.12626",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19167",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.628",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9489",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-product-approvals": "/ui-product-approvals/static-1.29509",
  "ui-tool-access": "/ui-tool-access/static-1.10565",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4107",
  "property-management-common": "/property-management-common/static-1.6623",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "/quartz-auth/static-1.1256",
  "quartz-test": "/quartz-test/static-1.1256",
  "quartz-tracking": "/quartz-tracking/static-1.960",
  "trellis-components": "/trellis-components/static-1.2951",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.488",
  "HubStyle": "/HubStyle/static-2.12207",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.111",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23468",
  "ContentUtils": "/ContentUtils/static-1.69330",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13439",
  "sassPrefix": "/sassPrefix/static-1.298",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.551",
  "batch-promise": "/batch-promise/static-1.1956",
  "event-emitter": "/event-emitter/static-1.1370",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5847",
  "magpie-types": "/magpie-types/static-1.5307",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1391",
  "avatar-components": "/avatar-components/static-1.2893",
  "breeze-engine-core": "/breeze-engine-core/static-1.1273",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.942",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41202",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13576",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.166",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15818",
  "ExportDialog": "/ExportDialog/static-6.10784",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.351",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.794",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42258",
  "reporting-snowflake": "/reporting-snowflake/static-1.57774",
  "reporting-ui-components": "/reporting-ui-components/static-2.66427",
  "reporting-visualizations": "/reporting-visualizations/static-1.61232",
  "trial-components-library": "/trial-components-library/static-1.14290",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.646",
  "navigation-components": "/navigation-components/static-1.19045",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1995",
  "simple-logging-lib": "/simple-logging-lib/static-1.3463",
  "nudge-client-utils": "/nudge-client-utils/static-1.3305",
  "fail-safe": "/fail-safe/static-1.363",
  "app-governance-lib": "/app-governance-lib/static-1.2573",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10947",
  "purchase-motions-components": "/purchase-motions-components/static-1.6553",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10604",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6140",
  "usage-tracker-public": "/usage-tracker-public/static-1.7534",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3739",
  "persist-promise": "/persist-promise/static-1.4113",
  "reference-resolvers": "/reference-resolvers/static-1.8590",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4326",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.744",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3420",
  "final-form": "/final-form/static-1.81",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3710",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6862",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5156",
  "content-assistance-lib": "/content-assistance-lib/static-1.8334",
  "content-media-capture": "/content-media-capture/static-1.5659",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10242",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24728",
  "growth-payments-core": "/growth-payments-core/static-1.26381",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3297",
  "payment-link-components": "/payment-link-components/static-1.24313",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20458",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10278",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9504",
  "video-components-external": "/video-components-external/static-1.12317",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "navigation-messaging": "/navigation-messaging/static-1.8372",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58929",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.445",
  "crm-component-utils": "/crm-component-utils/static-1.40045",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6299",
  "customer-data-properties": "/customer-data-properties/static-1.52867",
  "external-options-client-types": "/external-options-client-types/static-1.4407",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7305",
  "property-value-citations": "/property-value-citations/static-1.3481",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8514",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10789",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "cms-field-types": "/cms-field-types/static-1.5223",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "atom": "/atom/static-1.5488",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1133",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.659",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19450",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1128",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43973",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23637",
  "events-data-lib": "/events-data-lib/static-1.657",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5123",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4287",
  "hs-resources": "/hs-resources/static-1.604",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1412",
  "onboarding-tours": "/onboarding-tours/static-1.17295",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14655",
  "segments-client-types": "/segments-client-types/static-1.11943",
  "academy-common-lib": "/academy-common-lib/static-1.15278",
  "dashboard-lib": "/dashboard-lib/static-1.83135",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19159",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9120",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11512",
  "user-context": "/user-context/static-1.5476",
  "reporting-plugins": "/reporting-plugins/static-1.10897",
  "reporting-reports": "/reporting-reports/static-1.68834",
  "hubs-service-types": "/hubs-service-types/static-1.1673",
  "purchase-motions-api": "/purchase-motions-api/static-1.6556",
  "salesImages": "/salesImages/static-1.669",
  "signup-constants": "/signup-constants/static-1.19823",
  "nest": "/nest/static-1.646",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.973",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3062",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3381",
  "whisper-core-api": "/whisper-core-api/static-1.7520",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.314",
  "framework-listing-lib": "/framework-listing-lib/static-2.29694",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31633",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8469",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5510",
  "one-click-checkout": "/one-click-checkout/static-1.635",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7963",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15358",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10304",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.81",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29494",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13463",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4836",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3883",
  "seat-types-lib": "/seat-types-lib/static-1.927",
  "ui-addon-opt": "/ui-addon-opt/static-4.8785",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6769",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5493",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3939",
  "data-token-picker": "/data-token-picker/static-1.17034",
  "FileManagerLib": "/FileManagerLib/static-1.40368",
  "content-media-compositions": "/content-media-compositions/static-2.17470",
  "media-bridge-lib": "/media-bridge-lib/static-1.19548",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23459",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3726",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7301",
  "dnd-kit": "/dnd-kit/static-1.19",
  "card-properties-lib": "/card-properties-lib/static-1.45206",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37980",
  "crm-actions": "/crm-actions/static-1.6760",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44859",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10118",
  "customer-data-tracking": "/customer-data-tracking/static-1.7283",
  "calling-global-api": "/calling-global-api/static-1.65971",
  "calling-internal-common": "/calling-internal-common/static-1.31732",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67353",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59646",
  "commerce-products-lib": "/commerce-products-lib/static-1.10748",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4081",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4670",
  "crm-links": "/crm-links/static-1.6711",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4412",
  "formula-editor": "/formula-editor/static-1.14924",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4489",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1047",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3976",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49901",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4248",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.341",
  "smart-property-lib": "/smart-property-lib/static-1.8511",
  "tiered-pricing": "/tiered-pricing/static-1.2130",
  "topics-actions-lib": "/topics-actions-lib/static-1.584",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11337",
  "zustand": "/zustand/static-1.87",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.424",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7210",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1899",
  "growth-data-modal": "/growth-data-modal/static-1.6039",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3473",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2874",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1362",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8064",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6858",
  "academy-service-client": "/academy-service-client/static-1.4103",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40227",
  "SafeStorage": "/SafeStorage/static-1.4805",
  "video-embed": "/video-embed/static-1.36809",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25145",
  "viral-links-lib": "/viral-links-lib/static-1.7489",
  "nested-table": "/nested-table/static-1.647",
  "timezone-utils": "/timezone-utils/static-2.5641",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18568",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10630",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3642",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5770",
  "customer-data-views-management": "/customer-data-views-management/static-1.26210",
  "framework-data-table": "/framework-data-table/static-2.12733",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1646",
  "switchboard-lib": "/switchboard-lib/static-1.632",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1777",
  "app-users-service-client": "/app-users-service-client/static-1.6030",
  "app-users-service-types": "/app-users-service-types/static-1.5438",
  "mini-checkout-client": "/mini-checkout-client/static-1.27730",
  "onboarding-utils": "/onboarding-utils/static-1.5779",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29479",
  "checkout-sdk": "/checkout-sdk/static-3.24573",
  "payment-method-components": "/payment-method-components/static-1.7256",
  "touchless-buying-components": "/touchless-buying-components/static-1.6441",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3836",
  "edison-service-client-types": "/edison-service-client-types/static-1.804",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6993",
  "audio-components": "/audio-components/static-1.6482",
  "FileManagerImages": "/FileManagerImages/static-1.37879",
  "video-components": "/video-components/static-1.14319",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93069",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46912",
  "enrichment-lib": "/enrichment-lib/static-1.769",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4673",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2227",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20422",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19462",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11217",
  "crm-fe-perf": "/crm-fe-perf/static-1.23306",
  "calling-error-reporting": "/calling-error-reporting/static-1.31739",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11451",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6946",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2301",
  "commerce-permissions": "/commerce-permissions/static-1.1187",
  "products-iframe-lib": "/products-iframe-lib/static-1.8774",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11173",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10874",
  "sales-views-client-types": "/sales-views-client-types/static-1.4668",
  "bark-lib": "/bark-lib/static-1.16939",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.793",
  "policy-lib": "/policy-lib/static-1.7215",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10937",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2726",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2902",
  "user-context-client": "/user-context-client/static-1.4919",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4926",
  "outpost": "/outpost/static-1.4544",
  "draft-convert": "/draft-convert/static-2.82",
  "draft-extend": "/draft-extend/static-3.86",
  "draft-js": "/draft-js/static-5.88",
  "draft-plugins": "/draft-plugins/static-2.22261",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4257",
  "ts-utils-lib": "/ts-utils-lib/static-1.559",
  "copilot-messaging": "/copilot-messaging/static-1.2281",
  "crm-export-dialog": "/crm-export-dialog/static-1.6689",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2871",
  "crm-view-components": "/crm-view-components/static-1.1391",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.73",
  "customer-data-associations": "/customer-data-associations/static-1.7741",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.323",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15735",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47034",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.865",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4401",
  "company-details-components": "/company-details-components/static-1.6616",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.964",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16305",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3867",
  "social-insights-client-types": "/social-insights-client-types/static-1.22823",
  "crm_universal": "/crm_universal/static-1.22628",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38192",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13627",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56036",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22382",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19031",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72977",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5739",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.337",
  "data-agent-utils": "/data-agent-utils/static-1.806",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.114",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10360",
  "utility-belt": "/utility-belt/static-1.2945",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24084",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8142",
  "customer-data-rte": "/customer-data-rte/static-1.33797",
  "cv-backend-services": "/cv-backend-services/static-1.1601",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6434",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5514",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39067",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37078",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16554",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8026",
  "hub-http-contrib": "/hub-http-contrib/static-1.3437",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5614",
  "access-control-lib": "/access-control-lib/static-1.10839",
  "EmailComponents": "/EmailComponents/static-1.55733",
  "EmailData": "/EmailData/static-1.54411",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.692",
  "redux-less": "/redux-less/static-2.9872",
  "company-details-service-types": "/company-details-service-types/static-1.4353",
  "segments-query-core": "/segments-query-core/static-1.1838",
  "pricing-pages-api": "/pricing-pages-api/static-1.16170",
  "sequences-lib": "/sequences-lib/static-1.8675",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "products-ui-components": "/products-ui-components/static-1.41266",
  "reporting-enablement": "/reporting-enablement/static-1.24040",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7701",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56052",
  "commerce-products-api": "/commerce-products-api/static-1.2827",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58110",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103655",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81698",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29053",
  "ContentComponents": "/ContentComponents/static-2.72286",
  "ContentData": "/ContentData/static-1.69405",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2175",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47349",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2211",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19866",
  "automation-ui-types": "/automation-ui-types/static-1.20784",
  "messaging-types-lib": "/messaging-types-lib/static-1.47086",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4919",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8532",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.948",
  "price-books-api": "/price-books-api/static-1.1914",
  "price-books-components": "/price-books-components/static-1.1972",
  "property-description-translator": "/property-description-translator/static-1.4231",
  "ramp-editor": "/ramp-editor/static-1.1064",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14155",
  "report-customization-components": "/report-customization-components/static-1.14094",
  "reporting-filters": "/reporting-filters/static-1.1184",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2797",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3927",
  "totals-ui-components": "/totals-ui-components/static-1.24461",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9689",
  "advanced-menus-core": "/advanced-menus-core/static-1.15718",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6700",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7749",
  "data-token-views": "/data-token-views/static-1.17015",
  "forms-utils-lib": "/forms-utils-lib/static-1.13239",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13746",
  "react-tinymce": "/react-tinymce/static-1.56159",
  "simple-menus-core": "/simple-menus-core/static-1.15717",
  "simple-menus-lib": "/simple-menus-lib/static-1.17234",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55285",
  "tinymce-data": "/tinymce-data/static-1.41370",
  "tinymce-plugins": "/tinymce-plugins/static-1.58399",
  "tinymce-themes": "/tinymce-themes/static-1.57255",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16776",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35064",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7434",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3698",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2709",
  "ContentEditorUI": "/ContentEditorUI/static-2.78116",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.635",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4333",
  "web-interactives-components": "/web-interactives-components/static-1.14395",
  "web-interactives-data": "/web-interactives-data/static-1.14396",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1660",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1830",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1392",
  "line-items-api": "/line-items-api/static-1.1234",
  "merge-modal-lib": "/merge-modal-lib/static-1.12911",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4099",
  "FireAlarmUi": "/FireAlarmUi/static-1.4797",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4450",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22720",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22183",
  "data-studio-ubb": "/data-studio-ubb/static-1.3699",
  "interframe": "/interframe/static-3.5152",
  "layout-dnd-components": "/layout-dnd-components/static-1.13118",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12093",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9324",
  "campaigns-lib": "/campaigns-lib/static-1.27793",
  "content-management-data-lib": "/content-management-data-lib/static-1.6127",
  "copilot-plugins": "/copilot-plugins/static-1.12003",
  "cta-picker": "/cta-picker/static-1.37165",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4153",
  "editor-components": "/editor-components/static-1.13797",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8921",
  "error-messaging-js": "/error-messaging-js/static-1.5555",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86736",
  "layout-data-lib": "/layout-data-lib/static-1.10418",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.76",
  "redux-request-state": "/redux-request-state/static-1.11049",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2137",
  "smart-content-core": "/smart-content-core/static-1.43350",
  "smart-content-lib": "/smart-content-lib/static-1.44003",
  "social-composer-lib": "/social-composer-lib/static-1.60480",
  "structured-content-lib": "/structured-content-lib/static-1.26088",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54065",
  "tinymce-copilot": "/tinymce-copilot/static-1.17353",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8379",
  "automation-ui-routing": "/automation-ui-routing/static-1.22141",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5967",
  "attribution-lib": "/attribution-lib/static-1.42918",
  "voice-agents-components": "/voice-agents-components/static-1.3970",
  "forms-ai-lib": "/forms-ai-lib/static-1.4894",
  "codemirror-dlb": "/codemirror-dlb/static-1.59675",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6855",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36853"
}
};
